module.exports = __webpack_public_path__ + "img/FCB-3.4b363117.jpg";